import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/demo.vue";
import moment from 'moment'
import car from '../../../assets/images/car.png'
import { debounce } from '../../../utility/index'

export default {
    name: 'VehicleTrajectory',
    components: { tree, iTable, IPagination },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            ak: "zvDTLIRwKfdh465NSKTV2WZ43re61wv6",
            isSearch: true,
            carId: '',
            height: '320',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                height: false,
                mutiSelect: false,
                serialNumber: false,
            },
            columns: [
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                },
                {
                    prop: "onoffState",
                    label: this.$t('VehicleManagement.state'),
                    align: "center",
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.onoffState === '' ? '' : params.row.onoffState === 1 ? 'success' : 'info' }
                        }, params.row.onoffState === '' ? '' : params.row.onoffState === 1 ? this.$t('VehicleManagement.on') : this.$t('VehicleManagement.off'))
                    }
                },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [
                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,

            timeValue: [],
            carOptions: [
            ],
            terminalId: '',
            mapLoading: false,
            map: {},
            lushu: {},
            marker: {},
            polyline: '',
            carLabel: '',
            arr: [],
            pausePath: [],
            km: '0',
            tweenPoint: [],
            btnStatus: true,
            thatMap: '',
            carValue: '',
            lng: '',
            lat: '',
            carSpeed: 25,
            marks: {
                25: "x1",
                50: "x2",
                75: "x3",
                100: "x4",
            },
            newPoint: '',
        }
    },
    created() {
      
    },

    mounted() {
        this.initMap()
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        onSearch() {
            this.getRealTimeStatus()
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            this.getTime()
            this.getCarList()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getCarList()
        },
        getTime() {
            let endTime = moment().format("YYYY-MM-DD HH:mm:ss");
            let startTime = moment(endTime).subtract("2", "hour").format("YYYY-MM-DD HH:mm:ss");
            this.timeValue = [startTime, endTime];
        },
        getCarList() {
            let param = {
                orgId: this.id,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                carId: this.carId,
            }
            this.$store.dispatch('VehicleDistribution/GET_SELECTCARSTATE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onkeyUp() {
            this.pageNum = 1
            this.getCarList()
        },
        rowClick(row) {
            debounce(() => {
                this.terminalId = row.terminalId
                this.getRealTimeStatus()
            }, 1000)
        },

        // getLocation() {
        //     return new Promise((resolve, reject) => {
        //         var geolocation1 = new window.BMapGL.Geolocation();
        //         // 开启辅助定位     
        //         geolocation1.enableSDKLocation();
        //         geolocation1.getCurrentPosition(function (r) {
        //             if (this.getStatus() == BMAP_STATUS_SUCCESS) {
        //                 console.log(r)
        //                 resolve({ longitude: r.point.lng, latitude: r.point.lat })
        //             } else {
        //                 //防止出现定位不存在的情况
        //                 resolve({longitude:117.201057,latitude:31.693614}) ;
        //             }
        //         })
        //     });
        // },
        // async initMap() {
        //     const data = await this.getLocation()
        //     console.log(data)
        //     this.map = new BMap.Map("allmap1");
        //     this.map.centerAndZoom(new BMap.Point(data.longitude, data.latitude), 15);
        //     this.map.addControl(new BMap.MapTypeControl({
        //         anchor: BMAP_ANCHOR_TOP_LEFT,
        //     }));
        //     this.map.addControl(new BMap.ScaleControl({
        //         anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        //     }));
        //     this.map.addControl(new BMap.NavigationControl({
        //         anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        //     }));
        //     this.map.enableScrollWheelZoom();
        // },
        initMap() {
            this.map = new BMap.Map("allmap1");
            this.map.centerAndZoom(new BMap.Point(sessionStorage.getItem("longitude"), sessionStorage.getItem("latitude")), 15);
            this.map.addControl(new BMap.MapTypeControl({
                anchor: BMAP_ANCHOR_TOP_LEFT,
            }));
            this.map.addControl(new BMap.ScaleControl({
                anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
            }));
            this.map.addControl(new BMap.NavigationControl({
                anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
            }));
            this.map.enableScrollWheelZoom();
        },

        getRealTimeStatus() {
            let param = {
                terminalId: this.terminalId,
                startTime: this.timeValue[0],
                endTime: this.timeValue[1]
            }
            this.$store.dispatch('VehicleFiles/GET_CARTRAJECTORY', param).then(res => {
                if (res.data.code === 200) {
                    this.map.clearOverlays()
                    this.tweenPoint = []
                    if (!_.isEmpty(this.lushu)) {
                        console.log(this.lushu)
                        this.lushu.pause();
                        this.lushu.stop();
                    }
                    this.carValue = res.data.data.carId
                    this.carOptions = res.data.data.data

                    if (this.carOptions.length > 0) {
                        this.initCar();
                        this.marker.enableMassClear();
                        this.marker.hide();
                        this.lushu.start();
                    }
                    this.map.setZoom(20);
                } else {
                    this.$message.error(res.data.msg)
                    this.map.clearOverlays()
                    this.tweenPoint = []
                    if (this.lushu) {
                        this.lushu.pause();
                        this.lushu.stop();
                    }

                }
            }).catch(err => { })

        },
        initPolyline() {
            return new BMap.Polyline([], {
                strokeColor: "#5f77fd",
                strokeWeight: 2,
                strokeOpacity: 1,
            });
        },
        initLabel() {
            const label = new BMap.Label("", {
                offset: new BMap.Size(0, 30),
            });
            label.setStyle({
                border: "1px solid rgb(204, 204, 204)",
                color: "rgb(0, 0, 0)",
                borderRadius: "10px",
                padding: "5px",
                background: "rgb(255, 255, 255)",
            });

            return label;
        },

        initCar() {
            let t = this
            let arrPois = [];
            this.tweenPoint = [];

            this.polyline = this.initPolyline();
            this.carLabel = this.initLabel();

            this.carOptions.map((item) => {
                arrPois.push(new BMap.Point(item.longitude, item.latitude));
            });
            this.arr = arrPois;
            this.map.setViewport(arrPois);

            this.marker = new BMap.Marker(arrPois[0], {
                icon: new BMap.Icon(car, new BMap.Size(56, 28), {}),
            });
            this.marker.setShadow(null);
            this.marker.setLabel(this.carLabel);

            BMapLib.LuShu.prototype._move = function (initPos, targetPos, effect) {
                t.thatMap = this;
                let pointsArr = [initPos, targetPos];
                let me = this,
                    currentCount = 0,
                    timer = 10,
                    step = this._opts.speed / (1000 / timer),
                    init_pos = this._projection.lngLatToPoint(initPos),
                    target_pos = this._projection.lngLatToPoint(targetPos),
                    count = Math.round(me._getDistance(init_pos, target_pos) / step);
                this.pausePath = pointsArr;
                if (count < 1) {
                    me._moveNext(++me.i);
                    return;
                }
                this._map.addOverlay(t.polyline);
                this._map.addOverlay(t.marker);
                this._map.addOverlay(t.carLabel);

                me._intervalFlag = setInterval(function () {
                    if (currentCount >= count) {
                        this.km = Math.ceil(Math.random() * 4 + 1);

                        clearInterval(me._intervalFlag);
                        if (me.i > me._path.length) {
                            return;
                        }
                        me._moveNext(++me.i);
                    } else {
                        currentCount++;
                        var x = effect(init_pos.x, target_pos.x, currentCount, count),
                            y = effect(init_pos.y, target_pos.y, currentCount, count),
                            pos = me._projection.pointToLngLat(new BMap.Pixel(x, y));
                        if (currentCount == 1) {
                            var proPos = null;
                            if (me.i - 1 >= 0) {
                                proPos = me._path[me.i - 1];
                            }
                            if (me._opts.enableRotation == true) {
                                me.setRotation(proPos, initPos, targetPos);
                            }
                            if (me._opts.autoView) {
                                if (!me._map.getBounds().containsPoint(pos)) {
                                    me._map.setCenter(pos);
                                }
                            }
                        }
                        let catWord = "";
                        t.carOptions && t.carOptions.map((p, k) => {
                            if (
                                initPos.lng === p.longitude &&
                                initPos.lat === p.latitude &&
                                t.carOptions[k + 1].longitude == targetPos.lng &&
                                t.carOptions[k + 1].latitude == targetPos.lat
                            ) {
                                catWord = t.$t('common.carId') + ':' + t.carValue + "<br />" + t.$t('common.messageTime') + ':' + p.messageTime;
                            }
                        });
                        t.tweenPoint.push(pos);
                        t.polyline.setPath(t.tweenPoint);

                        me._marker.setLabel(t.carLabel);
                        t.carLabel.setContent(catWord);

                        me._marker.setPosition(pos);
                    }
                }, timer);
            };
            this.lushu = new BMapLib.LuShu(this.map, arrPois, {
                defaultContent: "",
                autoView: true,
                landmarkPois: [],
                icon: new BMap.Icon(car, new BMap.Size(56, 28), {}),
                speed: this.carSpeed,
                enableRotation: true,
            });
        },

        changeSlider(val) {
            if (val <= 25) {
                this.lushu._opts.speed = 100;
                return;
            } else if (val > 25 && val <= 50) {
                this.lushu._opts.speed = 400;
                return;
            } else if (val > 50 && val <= 75) {
                this.lushu._opts.speed = 800;
                return;
            } else {
                this.lushu._opts.speed = 1600;
                return;
            }
        },
        run() {
            this.map.clearOverlays();
            this.tweenPoint = [];
            if (this.lushu) {
                console.log(this.lushu)
                this.lushu.pause();
                this.lushu.stop();
            }
            if (this.carOptions.length == 0) {
                this.$message.error(this.$t('VehicleManagement.form.thereIsNoMotionTrajectoryInTheCurrentTimePeriod'));
            } else {
                if (this.timer) {
                    clearTimeout(this.timer);
                }
                this.timer = setTimeout(() => {
                    this.marker.enableMassClear();
                    this.marker.hide();
                    this.lushu.start();
                    this.btnStatus = true;
                }, 700);
            }
        },
        Continue() {
            if (this.carOptions.length == 0) {
                this.$message.error(this.$t('VehicleManagement.form.thereIsNoMotionTrajectoryInTheCurrentTimePeriod'));
            } else {
                this.btnStatus = true;
                this.thatMap._map.addOverlay(
                    new BMap.Polyline(this.pausePath, {
                        strokeColor: "#5f77fd",
                        strokeWeight: 2,
                        strokeOpacity: 1,
                    })
                );
                this.marker.enableMassClear();
                this.marker.hide();
                this.lushu.start();
            }
        },
        pause() {
            if (this.carOptions.length == 0) {
                this.$message.error(this.$t('VehicleManagement.form.thereIsNoMotionTrajectoryInTheCurrentTimePeriod'));
            } else {
                this.btnStatus = false;
                this.lushu.pause();
            }
        },

        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getCarList();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    },
    beforeDestroy() {
        this.map.clearOverlays()
        this.tweenPoint = []
        if (this.lushu) {
            this.lushu.stop()
        }
    }
}